// extracted by mini-css-extract-plugin
export default {"wrapper":"ObjectDataComponent_wrapper__GnorN","text":"ObjectDataComponent_text__bPVY3","title":"ObjectDataComponent_title__WCZm3"};